export default "__VITE_ASSET__Ct$vn2VI__"